import { BigNumber, Contract, ethers } from 'ethers';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useHasPendingApproval, useTransactionAdder } from '../state/transactions/hooks';
import useAllowance from './useAllowance';
import useTombFinance from './useTombFinance';

// returns a variable indicating the state of the approval and a function which agreeToTermss if necessary or early returns
function useAgreeToTerms(token: Contract): [boolean, () => Promise<void>] {
    const tombFinance = useTombFinance()
    const [hasAgreedToTerms, setHasAgreedToTerms] = useState(false);
  
    const updateState = useCallback(async () => {
      setHasAgreedToTerms(await tombFinance.hasAgreedToVaultTerms(token));
    }, [tombFinance?.isUnlocked, token, tombFinance]);
  
    useEffect(() => {
      if (tombFinance?.isUnlocked) {
        updateState().catch((err) => console.error(err.stack));
      }
    }, [tombFinance?.isUnlocked, updateState, tombFinance]);

    const addTransaction = useTransactionAdder();

    const agreeToTerms = useCallback(async (): Promise<void> => {
      if (hasAgreedToTerms === true) {
        console.error('agree to terms was called unnecessarily');
        return;
      }
  
      console.log("agreeToTerms", token)
      const response = await token.agreeToTerms();
      addTransaction(response);
    }, [hasAgreedToTerms, token, addTransaction]);
  
    return [hasAgreedToTerms, agreeToTerms];
}

export default useAgreeToTerms;
